import type { FrMrpaxeStaticFileIdFormat } from '../model.ts'

export const frMrpaxeRestGeneralTermsStaticFileId_v1_0_0 =
  'fr-mrpaxe-rest-general-terms-v1_0_0' as const satisfies FrMrpaxeStaticFileIdFormat

export const frMrpaxeRetaGeneralTermsStaticFileId_v1_0_0 =
  'fr-mrpaxe-reta-general-terms-v1_0_0' as const satisfies FrMrpaxeStaticFileIdFormat

export const frMrpaxeRestIpidStaticFileId_v1_0_0 =
  'fr-mrpaxe-rest-ipid-v1_0_0' as const satisfies FrMrpaxeStaticFileIdFormat

export const frMrpaxeRetaIpidStaticFileId_v1_0_0 =
  'fr-mrpaxe-reta-ipid-v1_0_0' as const satisfies FrMrpaxeStaticFileIdFormat

export const frMrpaxeStaticFilesIds_v1_0_0 = [
  frMrpaxeRestGeneralTermsStaticFileId_v1_0_0,
  frMrpaxeRetaGeneralTermsStaticFileId_v1_0_0,
  frMrpaxeRestIpidStaticFileId_v1_0_0,
  frMrpaxeRetaIpidStaticFileId_v1_0_0,
] as const satisfies readonly FrMrpaxeStaticFileIdFormat[]
